import React from 'react';
import Tag from './Tag';
import { classNames } from '../../Services/helpers';

const Tags = ({tags, center = false, muted = false, className, dismiss = null}) => {
    if (!tags) {
        return null;
    }

    const deduped = [...new Set(tags)];

    return <div className={classNames('flex flex-row gap-2 flex-wrap', center && 'justify-center', className)}>
        {deduped.map(tag => {
            return <Tag key={tag}
                        tag={tag}
                        muted={muted}
                        dismiss={dismiss}
                    />
        })}
    </div>
}

export default Tags;